module.exports = __webpack_public_path__ + "zvetseni-rtu-permalip_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-rtu-permalip_1_after.jpg
// module id = 1373
// module chunks = 0